(() => {
  const selector = '[data-fe-home-teaser]';

  const setup = (root) => {
    if (!root || root.dataset.feHomeTeaserReady === 'true') return;
    root.dataset.feHomeTeaserReady = 'true';

    const video = root.querySelector('[data-fe-home-teaser-video]');
    const playButton = root.querySelector('[data-fe-home-teaser-play]');
    const closeButton = root.querySelector('[data-fe-home-teaser-close]');
    if (!video || !playButton || !closeButton) return;

    const loadVideo = () => {
      if (video.dataset.loaded === 'true') return;
      video.querySelectorAll('source[data-src]').forEach((source) => {
        source.src = source.dataset.src;
      });
      video.dataset.loaded = 'true';
      video.load();
    };

    const openAndPlay = () => {
      loadVideo();
      if (video.ended) video.currentTime = 0;
      root.classList.add('is-open', 'is-playing');
      playButton.hidden = true;
      playButton.setAttribute('aria-expanded', 'true');
      closeButton.hidden = false;
      video.controls = true;
      video.muted = false;

      const playPromise = video.play();
      if (playPromise?.catch) {
        playPromise.catch(() => {
          root.classList.remove('is-playing');
          playButton.hidden = false;
        });
      }
    };

    const closeVideo = () => {
      video.pause();
      try {
        video.currentTime = 0;
      } catch (_) {
        // The poster remains available even when metadata has not loaded yet.
      }
      video.controls = false;
      video.muted = false;
      video.load();
      root.classList.remove('is-open', 'is-playing');
      playButton.hidden = false;
      playButton.setAttribute('aria-expanded', 'false');
      closeButton.hidden = true;
      playButton.focus({ preventScroll: true });
    };

    playButton.addEventListener('click', openAndPlay);
    closeButton.addEventListener('click', closeVideo);
    video.addEventListener('ended', () => {
      root.classList.remove('is-playing');
      playButton.hidden = false;
    });
  };

  const init = (scope = document) => {
    if (scope.matches?.(selector)) setup(scope);
    scope.querySelectorAll?.(selector).forEach(setup);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
